<div [ngClass]="[isFlexDesign ? 'board-alone' : 'board']">
  <div class="board-inner">
    <header class="board-header" [ngStyle]="{ display: kanbanGroup.title !== undefined ? 'block' : 'none' }">
      <h3 class="board-title js-board-handle">
        <span title="{{ kanbanGroup.title }}" class="board-title-text has-tooltip block-truncated">
          {{ kanbanGroup.title }}
        </span>
        <div title="{{ kanbanGroup.datas.length }}" class="issue-count-badge">
          <span class="issue-count-badge-count"> {{ kanbanGroup.datas.length }} </span>
        </div>
        <button
          [attr.aria-label]="'generic.add' | translate"
          title=""
          class="issue-count-badge-add-button btn btn-sm btn-default ml-1 has-tooltip js-no-trigger-collapse">
          +
        </button>
      </h3>
    </header>
    <div [ngClass]="[!this.kanbanGroup.title ? 'all' : '', 'board-list-component']">
      <ul
        #boardList
        data-board="64"
        [ngClass]="[isFlexDesign ? 'board-list-flex' : 'board-list']"
        cdkDropList
        [cdkDropListData]="kanbanGroup.datas"
        (cdkDropListDropped)="changeGroup($event)">
        @if (kanbanGroup.datas.length === 0) {
          <!-- visual only: drops still land on the cdkDropList ul -->
          @if (isLoading) {
            <li class="board-skeleton" aria-hidden="true">
              @for (i of [1, 2, 3]; track i) {
                <div class="board-skeleton-card">
                  <span class="board-skeleton-avatar"></span>
                  <span class="board-skeleton-lines"><span></span><span></span></span>
                </div>
              }
            </li>
          } @else {
            <li class="board-empty">{{ 'kanban.empty' | translate }}</li>
          }
        }
        <cdk-virtual-scroll-viewport
          [itemSize]="itemSize"
          [ngClass]="[isFlexDesign ? 'cdk-board-list-flex' : 'cdk-board-list']">
          <li
            #cardboard
            *cdkVirtualFor="
              let dataKanban of kanbanGroup.datas;
              trackBy: trackByFn.bind(this);
              let first = first;
              let last = last
            "
            cdkDrag
            tabindex="0"
            [cdkDragData]="dataKanban"
            (cdkDragStarted)="dragstart($event, cardboard, dataKanban)"
            (click)="onClick(dataKanban)"
            (keydown.enter)="onClick(dataKanban)"
            [class.user-can-drag]="!!kanbanGroup.columnName"
            [ngClass]="[isFlexDesign ? 'board-card-flex' : 'board-card']">
            <iu-kanban-card-ui
              [datasKanban]="dataKanban"
              [tableName]="tableName"></iu-kanban-card-ui>
          </li>
        </cdk-virtual-scroll-viewport>
      </ul>
    </div>
  </div>
</div>
